import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'react-bootstrap';
import { connect, useDispatch } from 'react-redux';

import i18n from 'I18n';
import { encode } from 'base-64';
import stringify from 'json-stable-stringify';
import QRCode from 'qrcode.react';

import { createAction, enLocaleNumberFormatter, getCustomerQRCodeData, getTranslationField } from 'utils';
import { NO_LEVEL, QRCODE_SHOW_RAW_MEMBERSHIP_ID } from 'utils/Config';

import './MyCard.scss';
import { MembershipCardBackgroundType } from 'utils/CustomEnums';
import { getLevelIndex } from 'utils/LevelUtils';

const QR_CODE_REFRESH_INTERVAL = 5 * 60 * 1000;

const mapStateToProps = (state) => {
  return {
    language: state.users.language,
    userInfo: state.users.userInfo,
    displayName: state.users.displayName,
    level: state.users.level,
    availablePoints: state.users.availablePoints,
    levelConfig: state.levels.levelConfig,
    currentLevelData: state.users.currentLevelData,
  };
};
function MyCard({
  language,
  userInfo,
  displayName,
  level,
  availablePoints,
  levelConfig,
  currentLevelData,
}) {
  const [refreshDatetime, setRefreshDatetime] = useState(null);
  const [codeDataString, setCodeDataString] = useState('code');

  const dispatch = useDispatch();

  const levelIndex = useMemo(() => {
    return getLevelIndex(level, levelConfig)
  }, [level, levelConfig]);

  const foregroundColor = currentLevelData.cardForegroundColor;
  const useCurrentLevelSingleColor = currentLevelData.cardBackgroundType === MembershipCardBackgroundType.SINGLE_COLOR;
  const useCurrentLevelImage = currentLevelData.cardBackgroundType === MembershipCardBackgroundType.IMAGE;

  const levelName = getTranslationField(
    currentLevelData,
    'levelName',
    language
  );

  useEffect(() => {
    dispatch(createAction('users/fetchBalance')({ updateLevel: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [language]);

  useEffect(() => {
    setRefreshDatetime(Date.now());
    const intervalID = setInterval(() => {
      setRefreshDatetime(Date.now());
    }, QR_CODE_REFRESH_INTERVAL);
    return () => {
      // cancel refresh qrcode
      if (!!intervalID) {
        clearInterval(intervalID);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!userInfo?.memberShipID || !refreshDatetime) {
      return;
    }
    const { uid, memberShipID } = userInfo;
    const codeString = getCustomerQRCodeData(uid, memberShipID, refreshDatetime);
    // console.log('codeString', codeString);
    setCodeDataString(codeString);
  }, [userInfo, refreshDatetime]);

  return (
    <Container className="my_card_container">
      {
        useCurrentLevelImage
          ? <img
            alt=""
            src={currentLevelData.myCardbackgroundImage}
            className="my-card-background-image my-card-content-config"
          />
          : null
      }
      <div
        className={`my-card-content my-card-content-config my-card-level-${levelIndex + 1}-color ${NO_LEVEL ? 'my-card-no-level' : ''}`}
        style={{
          ...(
            useCurrentLevelSingleColor
              ? { background: currentLevelData.cardBackgroundColor }
              : null
          ),
          ...(
            useCurrentLevelImage
              ? { background: "none" }
              : null
          ),
          ...(
            foregroundColor
              ? { color: foregroundColor }
              : null
          ),
        }}
      >
        <div className={`my-card-logo my-card-logo-config my-card-logo-level-${NO_LEVEL ? 0 : (levelIndex + 1)}`} />
        <p className="my_card_user_name title-small">
          {displayName}
        </p>
        <p className="my_card_user_id body-2">
          {`ID: ${userInfo?.memberShipID}`}
        </p>
        <div className="my_card_qrcode_view">
          <QRCode value={codeDataString} renderAs="svg" />
        </div>
        <div className="my_card_available_points">
          <p className='title-large'>{enLocaleNumberFormatter(availablePoints)} </p>
          <p className='headline'> {i18n.t('points')}</p>
        </div>
        {!NO_LEVEL && (
          <p
            className={`my_card_tier ${
              level === 2 ? 'level-2-text-color' : ''
            } subheading`}
          >
            {levelName}
          </p>
        )}
      </div>
    </Container>
  );
}

export default connect(mapStateToProps)(MyCard);
